/* eslint-disable import/prefer-default-export */

// Components
// export { default as Inspection160Point } from './components/Inspection160Point';
// export { default as CarroCertifiedBanner } from './components/CarroCertifiedBanner';

// Container
export { default as CCPOPageContainer } from './containers/CCPOPageContainer';
export { default as CCPOInspectionPointListContainer } from './containers/CCPOInspectionPointListContainer';
